import React from 'react'
import { Link } from 'react-router-dom'
import Bredcrumb from '../Bredcrumb/Main'
import BGImg from "../../assets/images/bread_crumb_bg.png"
//import bb from '../../'
import BGImg1 from "../../assets/images/bread_crumb_bg_one.png"
import BGImg2 from "../../assets/images/bread_crumb_bg_two.png"

const Main = ({ brdcum }) => {
    return (
      <>
        <Bredcrumb no={1} title="Privacy" tag="Privacy" bgimg={BGImg} />
  
        <section className="blog_detail_section">
          <div className="container">
            <div className="blog_inner_pannel">
              <div className="info">
                <h3>Privacy Policy</h3>
                <p>Last Updated: 08/08/2026</p>
                <p>
                  myFit is a personal health platform that helps you track,
                  organize and share your health information — health
                  records, medication and appointment reminders, and
                  day-to-day health stats like weight, blood pressure and
                  blood glucose. This Privacy Policy explains what
                  information we collect, how we use it, and the choices you
                  have. For the legal terms governing your use of myFit, see
                  our <Link to="/terms">Terms &amp; Conditions</Link>.
                </p>

                <h4>Information We Collect</h4>

                <p>
                  Account information you provide directly: your name and
                  email address. myFit uses passwordless sign-in — a one-time
                  code sent to your email — so we never store a password.
                </p>

                <p>
                  Health information you choose to enter or connect: health
                  records, medications, appointments, reminders, and health
                  stats such as weight, blood pressure and blood glucose. This
                  data is yours — you decide what to record and who, if
                  anyone, can see it.
                </p>

                <p>
                  Third-party account access: if you choose to link a
                  financial account to use certain features, that connection
                  is handled through our provider Salt Edge. myFit only
                  receives the information needed to provide the feature you
                  requested.
                </p>

                <h4>How We Use Your Information</h4>

                <p>
                  We use your information to provide the Service: storing and
                  displaying your health records, sending the reminders and
                  notifications you've set up, and letting you share
                  information with family members or caregivers you've
                  explicitly connected with through Connect. We do not sell
                  your personal information.
                </p>

                <h4>Family &amp; Connect Sharing</h4>

                <p>
                  myFit's Connect feature lets you share specific health
                  information with a family member or caregiver by scanning a
                  QR code. You control what's shared and can revoke access at
                  any time from Settings. Nothing is shared with another
                  account unless you've created that connection yourself.
                </p>

                <h4>Children's Privacy</h4>

                <p>
                  myFit is not directed to children under 13, and we do not
                  knowingly collect information from anyone under 13. Users
                  between 13 and 18 should have a parent or guardian's
                  permission to use the Service.
                </p>

                <h4>Data Security &amp; Retention</h4>

                <p>
                  We retain your information for as long as your account is
                  active. You can request deletion of your account and
                  associated data at any time by contacting us at{" "}
                  support@myfit.ai. We use reasonable technical and
                  organizational measures to protect your information, though
                  no method of transmission or storage is 100% secure.
                </p>

                <h4>Changes to This Policy</h4>

                <p>
                  We may update this Privacy Policy from time to time. We'll
                  post the revised policy here with an updated "Last Updated"
                  date. Continued use of the Service after a change means you
                  accept the updated policy.
                </p>

                <h4>Contact Us</h4>

                <p>
                  Questions about this Privacy Policy or your data? Email us
                  at support@myfit.ai.
                </p>

                {/* <ul>
                  <li>
                    <p>
                      {" "}
                      <span className="icon">
                        <i className="icofont-check-circled"></i>
                      </span>{" "}
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting in{" "}
                    </p>
                  </li>
                  <li>
                    <p>
                      {" "}
                      <span className="icon">
                        <i className="icofont-check-circled"></i>
                      </span>{" "}
                      Dustry lorem Ipsum has been the industrys standard dummy
                      text ev er since the when
                    </p>
                  </li>
                  <li>
                    <p>
                      {" "}
                      <span className="icon">
                        <i className="icofont-check-circled"></i>
                      </span>{" "}
                      Unknown printer took a galley of type and scrambled it to
                      make.
                    </p>
                  </li>
                  <li>
                    <p>
                      {" "}
                      <span className="icon">
                        <i className="icofont-check-circled"></i>
                      </span>{" "}
                      Type specimen book. It has survived not only five centuries,
                      but also the leap into electronic.
                    </p>
                  </li>
                  <li>
                    <p>
                      {" "}
                      <span className="icon">
                        <i className="icofont-check-circled"></i>
                      </span>{" "}
                      Lorem Ipsum is simply dummy text of the printing.
                    </p>
                  </li>
                  <li>
                    <p>
                      {" "}
                      <span className="icon">
                        <i className="icofont-check-circled"></i>
                      </span>{" "}
                      Dustry lorem Ipsum has been the industrys standard dummy
                      text ev er since.
                    </p>
                  </li>
                  <li>
                    <p>
                      {" "}
                      <span className="icon">
                        <i className="icofont-check-circled"></i>
                      </span>{" "}
                      Unknown printer took a galley of type and scrambled it to
                      make.
                    </p>
                  </li>
                  <li>
                    <p>
                      {" "}
                      <span className="icon">
                        <i className="icofont-check-circled"></i>
                      </span>{" "}
                      Type specimen book. It has survived not only.
                    </p>
                  </li>
                </ul> */}
              </div>
              {/* <div className="two_img">
                <div className="row">
                  <div className="col-md-6">
                    <img src="assets/images/blog_sub_01.png" alt="image" />
                  </div>
                  <div className="col-md-6">
                    <img src="assets/images/blog_sub_02.png" alt="image" />
                  </div>
                </div>
              </div>
              <div className="info">
                <h3>Why we are best</h3>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and typesetting
                  in dustry lorem Ipsum has been the industrys standard dummy text
                  ev er since the 1500s, when an unknown printer took a galley of
                  type and scrambled it to make a type specimen book. It has
                  survived not only five centuries, but also the leap into
                  electronic Lorem Ipsum is simply dummy text of the printing and
                  typesettingindustry lorem Ipsum has been the industrys standard
                  dummy text ever since the 1500s, when an unknown printer took a
                  galley of type and scrambled it to make a type specimen book. It
                  has survived.
                </p>
              </div>
              <div className="quote_block">
                <span className="q_icon">
                  <img src="assets/images/quote_icon.png" alt="image" />
                </span>
                <h2>
                  Lorem Ipsum is simply dummy text of the printing and typesetting
                  in dustry lorem Ipsum has been the industrys standard dummy.
                </h2>
                <p>
                  <span className="name">Mr. John Doe,</span> Apper Inc
                </p>
              </div>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                in dustry lorem Ipsum has been the industrys standard dummy text
                ev er since the 1500s, when an unknown printer took a galley of
                type and scrambled it to make a type specimen book. It has
                survived not only five centuries, but also the leap into
                electronic industry.
              </p>
              <div className="blog_authore">
                <div className="authore_info">
                  <div className="avtar">
                    <img src="assets/images/blog_d02.png" alt="image" />
                  </div>
                  <div className="text">
                    <h3>Name of App</h3>
                  </div>
                </div>
                <div className="social_media">
                  <ul>
                    <li>
                      <Link to="#">
                        <i className="icofont-facebook"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <i className="icofont-twitter"></i>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="blog_tags">
                <ul>
                  <li className="tags">
                    <p>Updated:</p>
                  </li>
                  <li>
                    <span>01-01-2023</span>
                  </li>
                </ul>
              </div> */}
            </div>
          </div>
        </section>
      </>
    );
  };

export default Main